var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-3"},[_c('div',[_c('router-link',{attrs:{"to":{
        name: 'course',
        params: {
          id: _vm.registration.course.id
        }
      }}},[_vm._v("\n      "+_vm._s(_vm.registration.course.title)+"\n    ")])],1),_c('div',[_vm._v("\n    "+_vm._s(_vm.$tc(_vm.$translate.NumberOfLessons))+":\n    "+_vm._s(_vm.registration.course.learningUnits.length)+"\n  ")]),_c('div',[_vm._v("\n    "+_vm._s(_vm.$tc(_vm.$translate.Status))+": "+_vm._s(_vm.statusFormatter(_vm.registration.status))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }